import {NgModule} from "@angular/core";
import {ProductSelectionComponent} from "./product-selection.component";
import {SharedModule} from "../../shared.module";

@NgModule({
    imports: [SharedModule],
    declarations: [ProductSelectionComponent],
    exports: [ProductSelectionComponent]
})
export class ProductSelectionModule { }
